var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'poster-csa',
    (_vm.coverSizeClass + "-csa"),
    !_vm.isProgressBar ? 'is-not-progress' : ''
  ]},[_c('wptv-icon',{staticClass:"icon-csa",attrs:{"name":'csa' + _vm.csa,"width":'',"height":'',"specific-alt":_vm.csaLabel(_vm.csa),"aria-hidden":"true","data-wptv":"item-poster-csa"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }